import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Transaction } from '../../models';
import { PseReturnTransaction } from '../../models/pseReturnTransaction';
import { TcReturnTransaction } from '../../models/tcReturnTransaction';
import { BevalidaReturnTransaction } from '../../models/BevalidaReturnTransaction';

import { AlertService } from '../../services/alert.service';
import { TokenServiceService } from '../../services/token-service.service';
import { PrintServicesService } from '../../services/print-services.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MASTERCARD, TC_STATUS } from '../../core/constants/credit-cards.constants';
import { API_V4_RESPONSE_NETWORK_CODES, COUNTRY_CODES, FLAGS_NAME, GENERAL_CONSTANTS, ORDER_STATES, PCOL_TRANSACTION_KEYS } from 'src/app/core/constants/General-constants';
import { COMMERCIAL_NETWORKS_NAMES, COMMERCIAL_NETWORKS_TIMEZONES } from 'src/app/core/constants/CommercialNetwork';
import { formatDate } from 'src/app/services/helps/datesHelper.helper';
import { PuntosColombiaService } from 'src/app/services/puntos-colombia.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';

@Component({
  selector: 'app-return',
  templateUrl: './return.component.html',
  styleUrls: ['./return.component.scss'],
})
export class ReturnComponent implements OnInit {

  constructor(
    private readonly authService: AuthService,
    private readonly alertService: AlertService,
    private readonly tokenServiceService: TokenServiceService,
    private readonly printServicesService: PrintServicesService,
    private readonly router: Router,
    private readonly pcoService: PuntosColombiaService,
    private featureFlagService: PayvalidaFeatureFlagService
  ) {
  }

  private token: string;
  pseReturnTransaction: PseReturnTransaction;
  tcReturnTransaction: TcReturnTransaction;
  beValidaTransaction: BevalidaReturnTransaction;
  transaction: Transaction;
  orderID: string;
  response: string;
  messageResponse: string;
  approve: boolean;
  fail: boolean;
  pend: boolean;
  icon: string;
  tc: any;
  loading: boolean;
  redirect: string;
  infoPayment: boolean;
  pColData: any = {};
  pColTransaction: any = {};
  ptsColTransaction: any = {};
  userInfo: any = {};
  enablePcoPointsAcummFF: boolean = false;
  acummulationByMerchantPcoFF: boolean = false;

  @Input() ngClass: any;

  static loadStyle(css: string) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css`;
    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }

  // TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/25139
  async ngOnInit() {
    this.infoPayment = false;
    this.loading = true;
    this.token = this.tokenServiceService.getToken();
    this.transaction = this.tokenServiceService.getAndDecodeToken();
    this.pColTransaction = JSON.parse(localStorage.getItem(`${PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_OBJECT_KEY}-${this.transaction.ORDER_REFERENCE}`)) ?? null;

    if (this.transaction != null && _.isObject(this.transaction)) {
      if ('MERCHANT_TEMPLATE' in this.transaction) {
        ReturnComponent.loadStyle(this.transaction.MERCHANT_TEMPLATE);
      }
    }

    this.orderID = this.authService.getOrderID();
    const summary = this.authService.getSummary();
    const tc = this.authService.getTC();
    this.userInfo = this.authService.getUserInfo();
    this.pColData = history?.state?.pColData;

    if (this.pColData != null) {
      this.processPCOL(this.pColData);

      return;
    }

    if (summary != null) {
      this.processBE(summary);

      return;
    }

    if (tc != null && tc.data != null) {
      if (this.pColTransaction != null && typeof this.pColTransaction === 'object') {
        this.processPCOL(this.pColTransaction, tc);

        return;
      }

      await this.processTC(tc);
    }

    if (tc != null && tc.CODE != null) {
      if (this.pColTransaction != null && typeof this.pColTransaction === 'object') {
        this.processPCOL(this.pColTransaction, tc);

        return;
      }

      await this.processTCNew(tc);
    }
  }

  async processTC(tc: any) {
    this.loading = false;
    if (tc.result === '200') {
      this.tcReturnTransaction = new TcReturnTransaction();
      this.tcReturnTransaction = tc.data.transaction;
      this.infoPayment = true;
      this.tcReturnTransaction.date = this.timeZoneChange(tc.data.commerce.net);

      if (this.tcReturnTransaction?.franchise && this.tcReturnTransaction.franchise === MASTERCARD.name) {
        this.tcReturnTransaction.franchise = MASTERCARD.newName;
      }
      switch (this.tcReturnTransaction.responseCode) {
        case ORDER_STATES.APPROVED:
          this.acummulationByMerchantPcoFFMethod();

          this.approved();
          break;

        case ORDER_STATES.REJECTED:
          this.failed();
          break;

        case ORDER_STATES.FAILED:
          this.failed();
          break;

        case ORDER_STATES.PENDING:
          this.pending();
          break;

        default:
          this.alertService.showAlertProblem();
          break;
      }
    } else {
      this.alertService.showAlertProblem();
    }
  }

  /**
   * @description returns if the status view of the voucher
   */
  async processTCNew(tc: any) {
    this.loading = false;
    if (this.apiV4ResponseCodes(tc.CODE)) {
      if (tc.DATA != null) {
        this.tcReturnTransaction = tc?.DATA?.transaction;
        this.infoPayment = true;

        this.tcReturnTransaction.date = this.timeZoneChange(tc?.DATA?.commerce?.net);
        if (
          this.tcReturnTransaction?.franchise &&
          this.tcReturnTransaction.franchise === MASTERCARD.name
        ) {
          this.tcReturnTransaction.franchise = MASTERCARD.newName;
        }
      }
      switch (tc.CODE) {
        case API_V4_RESPONSE_NETWORK_CODES.APROVED:
          this.acummulationByMerchantPcoFFMethod();

          this.approved();
          break;
        case API_V4_RESPONSE_NETWORK_CODES.REJECTED:
          this.failed();
          break;
        case API_V4_RESPONSE_NETWORK_CODES.WRONG_REQUEST:
        case API_V4_RESPONSE_NETWORK_CODES.INVALID_REQUEST:
        case API_V4_RESPONSE_NETWORK_CODES.INVALID_PAYMENT:
        case API_V4_RESPONSE_NETWORK_CODES.CONSULT_CASHIN_ERROR:
        case API_V4_RESPONSE_NETWORK_CODES.ANTI_FRAUD_ERROR:
        case API_V4_RESPONSE_NETWORK_CODES.ANTI_FRAUD_ALERT:
        case API_V4_RESPONSE_NETWORK_CODES.REGISTER_CASHIN_ERROR:
        case API_V4_RESPONSE_NETWORK_CODES.PROCESS_LAFISE_TRANSACTION_ERROR:
          this.failed();
          break;
        default:
          this.alertService.showAlertProblem();
          break;
      }
    } else if (tc.type === 'newForm') {
      this.tcReturnTransaction = tc.transaction;
      this.infoPayment = true;

      this.tcReturnTransaction.date = tc.date;
      this.tcReturnTransaction.franchise = tc.transaction.franchise;
      this.tcReturnTransaction.cardNumber = tc.card;
      switch (tc.status) {
        case TC_STATUS.CONFIRMED:
          this.acummulationByMerchantPcoFFMethod();

          this.approved();
          break;
        case TC_STATUS.REJECTED:
          this.failed();
          break;
        case TC_STATUS.FAILED:
        case TC_STATUS.ANTI_FRAUD_FAILED:
          this.failed();
          break;
        default:
          this.alertService.showAlertProblem();
          break;
      }
    }
    else {
      this.alertService.showAlertProblem();
    }
  }

  /**
  * @description returns if the response code belongs to those of v4 response codes
  */
  apiV4ResponseCodes(code: string) {
    return (code === API_V4_RESPONSE_NETWORK_CODES.APROVED ||
      code === API_V4_RESPONSE_NETWORK_CODES.REJECTED ||
      code === API_V4_RESPONSE_NETWORK_CODES.WRONG_REQUEST ||
      code === API_V4_RESPONSE_NETWORK_CODES.INVALID_REQUEST ||
      code === API_V4_RESPONSE_NETWORK_CODES.INVALID_PAYMENT ||
      code === API_V4_RESPONSE_NETWORK_CODES.CONSULT_CASHIN_ERROR ||
      code === API_V4_RESPONSE_NETWORK_CODES.ANTI_FRAUD_ERROR ||
      code === API_V4_RESPONSE_NETWORK_CODES.ANTI_FRAUD_ALERT ||
      code === API_V4_RESPONSE_NETWORK_CODES.REGISTER_CASHIN_ERROR ||
      code === API_V4_RESPONSE_NETWORK_CODES.PROCESS_LAFISE_TRANSACTION_ERROR);
  }

  processBE(summary: any) {
    this.loading = false;
    this.infoPayment = true;
    summary = this.authService.getSummary();
    const date = new Date();
    this.beValidaTransaction = new BevalidaReturnTransaction();
    this.beValidaTransaction.franquicia = GENERAL_CONSTANTS.BEVALIDA_STRING;
    this.beValidaTransaction.fecha = formatDate(date);;

    switch (summary.STATUS) {
      case ORDER_STATES.BEVALIDA_APPROVED:
        this.approved();
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    }
  }

  /**
 * @description This method manages redirection logic based on the status of the Puntos Colombia transaction evaluating
 * the status of the credit card transaction (if provided) to determine whether to redirect to views for pending,
 * rejected, failed or approved transactions.
 * @param pColSummary Summary information of the Puntos Colombia transaction selected by the user.
 * @param tcData Optional data from the credit card transaction, used to assess the transaction status and determine the appropriate view.
 */
  processPCOL(pColSummary: any, tcData?: any) {
    this.loading = false;
    this.infoPayment = true;
    this.ptsColTransaction = pColSummary;
    const date = new Date();
    this.ptsColTransaction.date = formatDate(date);

    if (tcData != null) {
      if (tcData.data?.transaction?.responseCodes === ORDER_STATES.PENDING) {
        return this.pending();
      }

      if (tcData.data?.transaction?.responseCodes === ORDER_STATES.REJECTED ||
        tcData.data?.transaction?.responseCodes === ORDER_STATES.FAILED) {
        return this.failed();
      }

      if (tcData.CODE != null && (tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.REJECTED ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.PROCESS_LAFISE_TRANSACTION_ERROR ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.WRONG_REQUEST ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.INVALID_REQUEST ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.INVALID_PAYMENT ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.CONSULT_CASHIN_ERROR ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.ANTI_FRAUD_ERROR ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.ANTI_FRAUD_ALERT ||
        tcData.CODE === API_V4_RESPONSE_NETWORK_CODES.REGISTER_CASHIN_ERROR)) {
        return this.failed();
      }
    }

    switch (this.ptsColTransaction.status) {
      case GENERAL_CONSTANTS.OK_RESPONSE_CODE:
        this.approved();

        this.enablePcoPointsAcummFFMethod();

        localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_OBJECT_KEY}-${this.transaction.ORDER_REFERENCE}`);
        break;

      default:
        this.alertService.showAlertProblem();
        break;
    }
  }

  approved() {
    this.response = 'exitoso';
    this.icon = 'check-circle';
    this.messageResponse =
      'Enviamos una notificación de tu pago al comercio.\n' +
      'Si tienes alguna duda, ponte en contacto con:';
    this.approve = true;
  }

  pending() {
    this.response = 'pendiente';
    this.icon = 'spinner';
    this.messageResponse =
      'Comunícate con el comercio para comprobar el estado de tu transacción';
    this.pend = true;
  }

  failed() {
    this.response = 'incorrecto';
    this.icon = 'exclamation-triangle';
    this.messageResponse =
      'Comunícate con el comercio para comprobar el estado de tu transacción';
    this.fail = true;
  }

  print() {
    this.printServicesService.downloadImage(
      document.getElementById('ticketDivTC'),
      'recibo_de_pago_payvalida',
    );
  }

  async retryPayment(): Promise<void> {
    await this.router.navigate(['/'], { queryParams: { token: this.token } });
  }

  /**
  * @description {timeZoneChange} determines the current date and time in either the Costa Rican or Colombian time zone based on
  * the provided countryNetwork parameter. It formats the date and time as a string in the 'YYYY-MM-DD HH:mm:ss' format
  * @returns {string} Formatted string representing a specific date
  */
  timeZoneChange(countryNetwork: string) {
    const date = new Date();
    let merchantTimeZone: string = '';

    switch (countryNetwork) {
      case COMMERCIAL_NETWORKS_NAMES.COOPENAE:
      case COMMERCIAL_NETWORKS_NAMES.COOPENAE_USD:
      case COMMERCIAL_NETWORKS_NAMES.LAFISE:
      case COMMERCIAL_NETWORKS_NAMES.LAFISE_USD:
        merchantTimeZone = COMMERCIAL_NETWORKS_TIMEZONES.CRC;
        break;
      case COUNTRY_CODES.COSTARICA.toString():
        merchantTimeZone = COMMERCIAL_NETWORKS_TIMEZONES.CRC;
        break;
      default:
        merchantTimeZone = COMMERCIAL_NETWORKS_TIMEZONES.COL;
        break;
    }

    const dateTimeFormat = new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: merchantTimeZone,
    });

    const [
      { value: month },
      ,
      { value: day },
      ,
      { value: year },
      ,
      { value: hour },
      ,
      { value: minute },
      ,
      { value: second },
      ,
      { value: dayPeriod },
    ] = dateTimeFormat.formatToParts(date);

    return `${year}-${month}-${day} ${hour}:${minute}:${second} ${dayPeriod}`;
  }

  /**
  * @description Handles the FF for Pco Points Acummulation and if is true, calls pcoCheckAndAcummPoints method
  */
  enablePcoPointsAcummFFMethod() {
    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.ENABLE_PCO_POINTS_ACUMM_FF, FLAGS_NAME.ENABLE_PCO_POINTS_ACUMM_FF).subscribe((response: boolean) => {
      this.enablePcoPointsAcummFF = response;

      if (this.enablePcoPointsAcummFF) {
        this.pcoService.pcoCheckAndAcummPoints(this.userInfo, this.token);
      }
    });
  }

  /**
  * @description Handles the FF for Pco Points Acummulation and if is true, calls pcoCheckAndAcummPoints method
  */
  acummulationByMerchantPcoFFMethod() {
    this.featureFlagService.getFeatureFlagValue(this.transaction.MERCHANT_ID, FLAGS_NAME.ACUMM_PCO_BY_MERCHANT).subscribe((response: boolean) => {
      this.acummulationByMerchantPcoFF = response;

      if (this.acummulationByMerchantPcoFF) {
        this.pcoService.pcoCheckAndAcummPoints(this.userInfo, this.token);
      }
    });
  }
}
